"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var mptc_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/mptc.png"));
var dgc_svg_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/dgc.svg"));
var trc_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/trc.png"));
var tc_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/tc.png"));
var cp_png_1 = __importDefault(require("@assets/components/home/trusted-by-sliver/cp.png"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return core_1.createStyles({
        trustedByText: (_a = {
                paddingBottom: theme.spacing(4),
                textAlign: 'center'
            },
            _a[theme.breakpoints.down('xs')] = {
                marginTop: theme.spacing(3),
                paddingBottom: theme.spacing(2),
            },
            _a),
        trustedLogosGroup: (_b = {
                justifyContent: 'center'
            },
            _b[theme.breakpoints.down('sm')] = {
                flexDirection: 'row',
                justifyContent: 'space-between',
            },
            _b),
        divider: (_c = {
                border: '2.5px solid #FFC700',
                maxWidth: 174,
                margin: '0 auto'
            },
            _c[theme.breakpoints.down('sm')] = {
                marginBottom: theme.spacing(2),
            },
            _c),
        trustedLogoGrid: (_d = {
                display: 'flex',
                userDrag: 'none',
                alignItems: 'center',
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                justifyContent: 'center'
            },
            _d[theme.breakpoints.down('sm')] = {
                marginTop: 0,
                marginBottom: 0,
            },
            _d),
        trustedLogo: (_e = {
                userDrag: 'none',
                objectFit: 'contain',
                maxWidth: 'min(100%, 120px)',
                maxHeight: '80%'
            },
            _e[theme.breakpoints.up('md')] = {
                maxWidth: 'min(100%, 150px)',
            },
            _e[theme.breakpoints.up('lg')] = {
                maxWidth: 'min(100%, 180px)',
            },
            _e[theme.breakpoints.down('sm')] = {
                maxHeight: '100%',
            },
            _e['@media screen\\0'] = (_f = {
                    maxWidth: '120px',
                    maxHeight: 'calc(0.7px * 120)'
                },
                _f[theme.breakpoints.up('md')] = {
                    maxWidth: '150px',
                    maxHeight: 'calc(0.7px * 150)',
                },
                _f[theme.breakpoints.up('lg')] = {
                    maxWidth: '180px',
                    maxHeight: 'calc(0.7px * 180)',
                },
                _f),
            _e),
    });
});
var TrustedBySliver = function () {
    var t = react_i18next_1.useTranslation().t;
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var trustedLogos = [
        { name: t('homePage.trustedBy.1'), icon: mptc_png_1.default },
        { name: t('homePage.trustedBy.2'), icon: dgc_svg_1.default },
        { name: t('homePage.trustedBy.3'), icon: trc_png_1.default },
        { name: t('homePage.trustedBy.4'), icon: tc_png_1.default },
        { name: t('homePage.trustedBy.5'), icon: cp_png_1.default },
    ];
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { className: classes.trustedByText, variant: "h3", color: "textPrimary", gutterBottom: true }, t('homePage.featureListSliverHeader')),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Grid, { className: classes.trustedLogosGroup, container: true, spacing: isMobileView ? 1 : 10 }, trustedLogos.map(function (trustedLogo) { return (react_1.default.createElement(core_1.Grid, { item: true, className: classes.trustedLogoGrid, key: trustedLogo.name, xs: 2 },
                react_1.default.createElement("img", { className: classes.trustedLogo, src: trustedLogo.icon, alt: trustedLogo.name }))); })))));
};
exports.default = TrustedBySliver;
